import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import AnswerButtonGroup from "@/components/train/AnswerButtonGroup.vue";
import GraphMatchMatrix from "@/components/subject/GraphMatch/GraphMatchMatrix.vue";
export default {
  name: "GraphMatchRender",
  components: {
    AnswerButtonGroup,
    GraphMatchMatrix
  },
  props: {
    review: {
      type: Object,
      default: () => null
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    gridSize() {
      return Number(this.data?.gridSize || 3);
    },
    options() {
      return Array.isArray(this.data?.options) ? this.data.options : [];
    },
    optionIds() {
      if (this.options.length === 0) {
        return ["A", "B", "C", "D"];
      }
      return this.options.map(op => op.id);
    },
    correctAnswer() {
      return this.data?.rightAnswer || this.data?.correctOptionId || "";
    }
  },
  methods: {
    optionAt(index) {
      return this.options[index] || {
        id: "",
        matrix: []
      };
    },
    onChoosed(list) {
      this.$emit("answer", list && list.length > 0 ? list[0] : null);
    }
  }
};